var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-textarea"},[_c('textarea',_vm._g({staticClass:"base-textarea__field",class:{ error: !!_vm.error },attrs:{"placeholder":_vm.label}},_vm.inputListeners),[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }